import React from 'react'
import { observer } from 'mobx-react'
import { observable, action } from 'mobx'
import * as defaultConst from '../../constants/default_constants'
import momentTZ from 'moment-timezone'
import ModalWindow from '../utils/modal'
import SelectedChips from './selected_chips'
import {
  Badge,
  Button,
  Checkbox,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  HelpBlock,
  InputGroup,
  OverlayTrigger,
  Popover,
  Tab,
  Tabs,
  Tooltip
} from 'react-bootstrap'

const _RegionsInput = observer(({
  record, disabled, attr, autoOrder, autoOrderToggle, label, onChange,
  optionsrecord, optionsattr, hideCheckbox, errors, validationSuccess, tzInfo,
  newCountries, newNegative, setNegative, showModal, modalWindow, latestTab, setLatestTab, ...rest
}) => {
  const errorText = errors ? errors.get(attr) : undefined
  const validationState = errorText ? 'error' : (validationSuccess ? 'success' : null)
  let value = record.get(attr) || ''

  if (hideCheckbox && value && value.length > 0 && value[0] === '-') {
    // remove '-' if disabled by hideCheckbox
    value = value.substring(1)
    onChangeLocal(attr, value)
  }

  const options = optionsrecord.get(optionsattr)
  const timeZones = optionsrecord.has('TimeZones') ? optionsrecord.get('TimeZones') : null
  const minus = value.length > 0 && value[0] === '-'
  let parts = value ? value.split(',') : []
  let lastChar = ''

  const toolTip = optionsattr && options && (
    <Tooltip id={optionsattr}>Enum ID:&nbsp;
      <strong>{optionsattr}</strong>
    </Tooltip>
  )

  function onChangeLocal (attr, partsLoc, orderLoc = false) {
    if (disabled) { return true } // region component disabled
    partsLoc = partsLoc ? partsLoc.split(',') : []
    if (minus && partsLoc[0] && partsLoc[0] === '-') {
      partsLoc[0] = partsLoc[0].substring(1)
    }
    const partsFinal = []
    // remove dupliactes
    partsLoc.forEach(function (item) {
      if (partsFinal.indexOf(item) < 0) {
        partsFinal.push(item)
      }
    })
    if (autoOrder === true || orderLoc) {
      if (partsFinal && partsFinal[0] && partsFinal.slice(-1)[0].length >= 2) {
        partsFinal.sort()
        if (partsFinal[0] === '') {
          partsFinal.shift()
          partsFinal.push('')
        }
      }
    }
    if (minus && partsFinal.length > 0 && partsFinal[0][0] !== '-') {
      partsFinal[0] = ('-' + partsFinal[0])
    }
    onChange(attr, partsFinal.join(','))
  }

  function autoOrderLocal () {
    if (disabled) { return true } // region component disabled
    onChangeLocal(attr, parts.join(','), true)
    autoOrderToggle()
  }

  function onChipDelete (chipval) {
    if (disabled) { return true } // region component disabled
    parts.splice(parts.indexOf(chipval), 1)
    if (minus && parts.length > 0 && parts[0][0] !== '-') {
      parts[0] = ('-' + parts[0])
    }
    onChangeLocal(attr, parts.join(','))
  }

  function onCountrySelect (a, val, close) {
    if (disabled) { return true } // region component disabled
    if (minus && parts.length === 1 && parts[0] === '-') {
      parts = []
      val = ('-' + val)
      parts.push(val)
    } else {
      if (minus && parts.length > 0 && parts[0][0] === '-') {
        parts[0] = parts[0].substring(1)
        parts.unshift('-' + val)
      } else {
        parts.unshift(val)
      }
    }
    onChangeLocal(attr, parts.join(','))
    close && modalWindow(false)
  }

  function handleCBChange (v) {
    if (disabled) { return true } // region component disabled
    const pre = minus ? '' : '-'
    if (minus && parts.length > 0 && parts[0][0] === '-') {
      parts[0] = parts[0].substring(1)
    }
    onChange(attr, pre + parts.join(','))
  }

  const setOneCountry = (oneCountry, only = false, checked) => {
    let pre = ''
    oneCountry = oneCountry && oneCountry[0] === '-' ? oneCountry.substr(1) : oneCountry
    const isOneCountry = parts.includes(oneCountry)
    const isOneNegativeCountry = parts.includes('-' + oneCountry)
    if (checked) {
      return isOneCountry || isOneNegativeCountry
    }
    if (only === true || oneCountry === '') {
      parts = (!only || isOneCountry || isOneNegativeCountry ? [] : [oneCountry])
      pre = (isOneNegativeCountry && oneCountry !== '' ? '-' : '')
    } else if (isOneCountry) {
      parts.splice(newCountries.indexOf(oneCountry), 1)
    } else if (isOneNegativeCountry) {
      parts.splice(newCountries.indexOf(isOneNegativeCountry), 1)
      pre = '-'
    } else if (parts[0] === '-') {
      parts = [oneCountry]
      pre = '-'
    } else {
      parts.push(oneCountry)
    }
    onChangeLocal(attr, pre + parts.join(','))
  }

  const updateCountries = (values, remove, all, replace) => {
    if (values === 'WW' || replace) {
      newCountries.clear()
      setNegative(false)
    } else if (values && newCountries.includes('WW')) {
      newCountries.splice(newCountries.indexOf('WW'), 1)
    }
    values = values ? values.split(',') : []
    remove = !all && (values.length > 1 && newCountries.indexOf(values[0]) > -1) ? true : remove
    values.map(i => {
      if (remove) {
        newCountries.splice(newCountries.indexOf(i), 1)
      } else if (newCountries.indexOf(i) < 0) {
        newCountries.push(i)
      }
    })
  }

  const saveNewCountries = () => {
    parts = []
    newCountries.map(i => {
      parts.push(i)
    })
    onChange(attr, (newNegative ? '-' : '') + parts.join(','))
    modalWindow(null, [])
  }

  const mapCountries = (i, firstChar = false) => {
    let addButton
    if (firstChar && lastChar !== firstChar) {
      lastChar = firstChar
      const continent = optionsrecord.get(optionsattr).find(f => f.text === firstChar)
      if (continent && continent.value && continent.value.indexOf(',') > 0) {
        const allSelected = continent.value.split(',').every(i => newCountries.includes(i))
        addButton = <Checkbox checked={allSelected}
          onClick={() => updateCountries(continent.value, allSelected, true)}></Checkbox>
      }
    } else {
      firstChar = false
    }

    return i && i.value && (
      <span key={i.value}>
        {firstChar && <h6 className='regions-title'>{firstChar}:{addButton}</h6>}
        <OverlayTrigger trigger={['hover', 'focus']} placement='right'
          overlay={<Popover>{i.value && i.value.replace(/,/g, ', ')}</Popover>}>
          <FormGroup>
            {i.value.indexOf(',') > -1
              ? <Button bsSize='small' onClick={() => updateCountries(i.value)} style={{ marginRight: '0.5em' }}>
                {i.text}
              </Button>
              : <Checkbox inline className='regions-checkbox' onClick={() => (newCountries.includes(i.value)
                ? updateCountries(i.value, true)
                : updateCountries(i.value))}
              checked={newCountries.includes(i.value) || newCountries.includes('-' + i.value)} value={i.value}>
                {i.text}
              </Checkbox>
            }
          </FormGroup>
        </OverlayTrigger>
      </span>
    )
  }

  const countriesByContinents = ['Africa', 'Asia', 'Australia (Oceania)', 'Europe', 'North America', 'South America']

  const modalRegions = optionsrecord.get(optionsattr)
    .filter(i => i.value.indexOf(',') < 0)
    .map((i) => mapCountries(i, i.text && i.text[0]))

  const modalContinentsButtons = optionsrecord.get(optionsattr)
    .filter(i => i.value.indexOf(',') > -1)
    .map((i) => mapCountries(i, false))

  const modalContinentsList = [
    mapCountries(optionsrecord.get(optionsattr).find(k => k && k.value === 'WW'), 'World wide')]
    .concat(
      [...optionsrecord.get(optionsattr)
        .filter(i => i.value.indexOf(',') > -1 && countriesByContinents.includes(i.text))
        .map(i => i.value.split(',')
          .map(j => mapCountries(optionsrecord.get(optionsattr)
            .find(k => k && k.value === j), i.text)))
      ], [mapCountries(optionsrecord.get(optionsattr).find(k => k && k.value === 'AQ'), 'Antarctica')])

  const modalGroupOfCountries = [
    ...optionsrecord.get(optionsattr)
      .filter(i => i.value.indexOf(',') > -1 && !countriesByContinents.includes(i.text))
      .map(i => i.value.split(',')
        .map(j => mapCountries(optionsrecord.get(optionsattr)
          .find(k => k && k.value === j), i.text)))
  ]

  const listOfUnselectedItems = []
  const listOfUnselected = newCountries && newCountries.length > 0 && newCountries[0] &&
    !newCountries.includes('WW') && optionsrecord && optionsrecord.get(optionsattr)
    .filter(f => !newCountries.includes(f.value) && f.value.indexOf(',') < 0 && f.value !== 'WW')
    .map((f, k) => {
      listOfUnselectedItems.push(f.value)
      return <span key={k}>
        {k > 0 && ', '}
        <OverlayTrigger trigger={['hover', 'focus']} placement='right' overlay={<Popover>{f.text}</Popover>}>
          <span>{f.value}</span></OverlayTrigger>
      </span>
    })

  const countriesLength = newCountries && newCountries.length > 0 && newCountries.length
  const unselectedLength = listOfUnselected && listOfUnselected.length > 0 && listOfUnselected.length

  const modalChecklist = (<div>
    <h6 className='regions-title'>
      {newNegative ? 'Selection' : 'Selected countries'} &nbsp;
      {countriesLength && <Badge>{countriesLength}</Badge>}
    </h6>
    {countriesLength
      ? newCountries.map(i => optionsrecord.get(optionsattr).find(j => i === j.value)).map((f, k) => <span key={k}>
        {k > 0 ? ', ' : (k === 0 && newNegative ? '-' : '')}
        {f && <OverlayTrigger trigger={['hover', 'focus']} placement='right' overlay={<Popover>{f.text || f.value}</Popover>}>
          <span>{f.value}</span></OverlayTrigger>}
      </span>)
      : <em>-empty-</em>
    }
    <h6 className='regions-title'>
      {newNegative ? 'Results of negative selection' : 'Unselected countries'} &nbsp;
      {unselectedLength && <Badge>{unselectedLength}</Badge>}
      {unselectedLength &&
        <Button bsSize='small' bsStyle='info' onClick={() => updateCountries(listOfUnselectedItems.join(','), false, false, true)} style={{ marginLeft: '0.5em' }}>
          <i className='glyphicon glyphicon-retweet'/>&nbsp; Use this selection as the main
        </Button>}
    </h6>
    {unselectedLength
      ? listOfUnselected
      : <em>-empty-</em>
    }
  </div>)

  const rowSize = 'col-xs-4 col-lg-3'

  return <FormGroup controlId={attr} validationState={validationState}>
    <ControlLabel>{label} {parts && parts.length > 0 && <Badge>{parts.length}</Badge>} </ControlLabel>
    {label && optionsattr &&
        <OverlayTrigger placement='right' overlay={toolTip}>
          <i className='glyphicon glyphicon-list-alt' style={{ fontSize: '0.75em', marginLeft: '0.7em' }}/>
        </OverlayTrigger>}

    <div className='row regions-control'>
      <div className={rowSize}>
        <Checkbox disabled={disabled} checked={autoOrder} onChange={autoOrderLocal}>Auto-order</Checkbox>
      </div>
      <div className={rowSize}>
        <Checkbox disabled={disabled} checked={setOneCountry('WW', true, true)} onChange={() => setOneCountry('WW', true)}>World wide</Checkbox>
      </div>
      {!hideCheckbox &&
        <div className={rowSize}>
          <Checkbox disabled={disabled} checked={minus} onChange={handleCBChange}><strong>&ndash;</strong> Negative selection</Checkbox>
        </div>}
      <div className={rowSize}><div className='text-danger'>&nbsp;
        <span className='text-danger'onClick={() => (disabled || (parts && parts.length <= 0)) ? null : setOneCountry('')}>
          <i className='glyphicon glyphicon-remove'/> Remove all
        </span></div>
      </div>
    </div>

    <FormGroup>
      <InputGroup validationState={errorText ? 'error' : ''}>
        <InputGroup.Button>
          <Button disabled={disabled} bsStyle={errorText ? 'danger' : 'info'} onClick={() => modalWindow(true, parts, minus)}>
            <i className='glyphicon glyphicon-plus' />&nbsp; Add region</Button>
        </InputGroup.Button>
        <FormControl
          disabled={disabled} className={disabled && 'disabled-input-style'}
          componentClass='input' name={attr} value={value || ''}
          onChange={(evt) => onChangeLocal(attr, evt.target.value.toUpperCase())} {...rest} />
        <FormControl.Feedback />
      </InputGroup>
    </FormGroup>

    {errorText && <HelpBlock>{errorText}</HelpBlock>}

    <SelectedChips
      value={parts}
      onDelete={onChipDelete}
      getText={val => {
        const found = options.find(i => {
          return i.value === (val.toString()[0] === '-' ? val.toString().substring(1) : val.toString())
        })
        return found ? found.text : null
      }}
      getTZ={val => {
        const tzEnum = tzInfo && val && timeZones && timeZones.find(f => f.value === val)
        const tzText = tzEnum && tzEnum.text ? tzEnum.text : defaultConst.DATE_GMT_TZ
        const tzValue = tzText && (
          momentTZ.tz([new Date().getFullYear(), 0], tzText).format('Z').concat('/') +
          momentTZ.tz([new Date().getFullYear(), 5], tzText).format('Z'))
        return tzInfo && tzValue
          ? (' (' + tzValue + ' ' + tzText + ')')
          : null
      }} />

    {showModal && <ModalWindow title={'Regions'} save={() => saveNewCountries()} hide={() => modalWindow(null)}
      text={<Form inline>
        <Tabs defaultActiveKey={latestTab || 1} onSelect={(key) => setLatestTab(key)}>
          <Tab eventKey={1} title='Countries by continents'>{modalContinentsList}</Tab>
          <Tab eventKey={2} title='Groups of countries'>{modalGroupOfCountries}</Tab>
          <Tab eventKey={3} title='Countries alphabetically'>{modalRegions}</Tab>
          <Tab eventKey={4} title='Countries checklist'>{modalChecklist}</Tab>
        </Tabs>
      </Form>} />
    }
  </FormGroup>
})

class RegionsInputWrapper extends React.Component {
  state = {
    autoOrder: !(this.props.record && this.props.record.has('id'))
  }

  autoOrderToggle = () => this.setState({ autoOrder: !this.state.autoOrder })

  @observable showModal = null
  @observable latestTab = 1
  @observable newCountries = []
  @observable newNegative = false

  @action setLatestTab (val) {
    this.latestTab = val
  }

  @action setNegative (val) {
    this.newNegative = val
  }

  @action modalWindow (val, defaultValues, minus) {
    if (defaultValues && defaultValues instanceof Array) {
      if (defaultValues && defaultValues[0] === '-') {
        defaultValues.shift()
      } else if (defaultValues && defaultValues[0] && defaultValues[0][0] === '-') {
        defaultValues[0] = defaultValues[0].substring(1)
      }
      this.newCountries.clear()
      defaultValues.map(i => {
        this.newCountries.push(i)
      })
    }
    this.newNegative = minus && true
    this.showModal = val

    if (this.props.store && this.props.store.cv) {
      this.props.store.cv.modalIsOpen = val
    }
  }

  render () {
    return (
      <_RegionsInput
        {...this.props}
        autoOrder={this.state.autoOrder}
        autoOrderToggle={this.autoOrderToggle.bind(this)}
        latestTab={this.latestTab}
        modalWindow={this.modalWindow.bind(this)}
        newCountries={this.newCountries}
        newNegative={this.newNegative}
        setLatestTab={this.setLatestTab.bind(this)}
        setNegative={this.setNegative.bind(this)}
        showModal={this.showModal}
      />
    )
  }
}

export default observer(RegionsInputWrapper)
